import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/new-axelerate-logo.svg'


const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-white bg-primary py-2" }
const _hoisted_3 = { class: "container flex flex-row justify-between items-center" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-6"
}, null, -1)
const _hoisted_6 = { class: "flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuDropDown = _resolveComponent("MenuDropDown")!
  const _component_NavBar = _resolveComponent("NavBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_MenuDropDown, { onLogOut: _ctx.logOut }, null, 8, ["onLogOut"])
        ])
      ])
    ]),
    (_ctx.$route.name === 'Account settings')
      ? (_openBlock(), _createBlock(_component_NavBar, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}